import { css, keyframes } from '@emotion/react';
import React from 'react';
import PropTypes from 'prop-types';
import SubMenu from './SubMenu';
import { Box, Flex, BoxVisible, Container, BoxInline } from '../../../style/basicStyle';
import colors from '../../../utils/colors';

export const displayHidden = css`
  display: none;
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  left: -99999px;
`;

const w48 = css`
  width: 12rem;
`;

const bgDark = css`
  background: ${colors.secondary};
`;

const bgLight = css`
  background: ${colors.primary};
  opacity: 0.85;
`;

const absolute = css`
  position: absolute;
`;

// Dropdown animation keyframes
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-10px);
  }
`;

const dropdownMenu = css`
  display: block !important;
  border-radius: 5px;
  width: 100%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const dropdownVisible = css`
  opacity: 1;
  transform: translateY(0);
  animation: ${fadeIn} 0.2s ease-out forwards;
`;

const dropdownHidden = css`
  position: absolute;
  pointer-events: none;
  opacity: 0;
  animation: ${fadeOut} 0.2s ease-out forwards;
`;

// eslint-disable-next-line react/prop-types
const Menu = ({ 
  linkName, 
  isVisible = false, 
  childLinks, 
  hidden = false, 
  childLinkStyling, 
  navDarkActive = false, 
  toggleNav, 
  authUser, 
  requireAuth = false, 
  requireAdmin = false, 
  requireOrders = false, 
  requireTournaments = false, 
  requireTuition = false, 
  requireEvents = false, 
  hideWithAuth = false,
  roleRequired = '',
}) => {
  return (
    <Box css={[hidden && displayHidden, absolute, w48, childLinkStyling, isVisible ? dropdownVisible : dropdownHidden]}>
      <Box mt={[1]} px={[1]} py={[1]} css={[(navDarkActive && bgDark) || bgLight, dropdownMenu]}>
        <SubMenu key={linkName} linkName={linkName} hidden={hidden} hideWithAuth={hideWithAuth} toggleNav={toggleNav} authUser={authUser} requireTuition={requireTuition} requireAuth={requireAuth} requireTournaments={requireTournaments} roleRequired={roleRequired} requireAdmin={requireAdmin}  requireEvents={requireEvents} requireOrders={requireOrders} navDarkActive={navDarkActive} childLinks={childLinks} />
      </Box>
    </Box>
  );
};
export default Menu;

Menu.propTypes = {
  isVisible: PropTypes.bool,
  navDarkActive: PropTypes.bool,
  hidden: PropTypes.bool,
  requireAuth: PropTypes.bool,
  requireAdmin: PropTypes.bool,
  requireOrders: PropTypes.bool,
  requireEvents: PropTypes.bool,
  requireTournaments: PropTypes.bool,
  roleRequired: PropTypes.string,
  requireTuition: PropTypes.bool,
  hideWithAuth: PropTypes.bool,
  childLinks: PropTypes.arrayOf(
    PropTypes.shape({
      linkName: PropTypes.string,
      link: PropTypes.string,
      categoryName: PropTypes.string
    })
  ).isRequired
};
